import React from "react";
import Chart from "react-apexcharts";

const SummaryChart = ({ monthGraph, currentMonthGraph, prevMonthGraph }) => {
  const options = {
    chart: {
      height: 100,
      minHeight: 100,
      type: "line",
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 3,
      curve: "smooth",
    },
    legend: {
      tooltipHoverFormatter: function (val, opts) {
        return (
          val +
          " - <strong>" +
          opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
          "</strong>"
        );
      },
    },
    markers: {
      size: 0,
      hover: {
        sizeOffset: 6,
      },
    },
    xaxis: {
      categories: [
        "Day 1",
        "Day 2",
        "Day 3",
        "Day 4",
        "Day 5",
        "Day 6",
        "Day 7",
        "Day 8",
        "Day 9",
        "Day 10",
        "Day 11",
        "Day 12",
        "Day 13",
        "Day 14",
        "Day 15",
        "Day 16",
        "Day 17",
        "Day 18",
        "Day 19",
        "Day 20",
        "Day 21",
        "Day 22",
        "Day 23",
        "Day 24",
        "Day 25",
        "Day 26",
        "Day 27",
        "Day 28",
        "Day 29",
        "Day 30",
      ],
      labels: {
        show: false,
      },
      title: {
        text: "Days",
        align: "center",
        margin: 0,
        offsetY: -10,
        style: {
          fontSize: "10px",
          color: "#00e396",
        },
      },
    },
    yaxis: {
      title: {
        text: "Orders",
        align: "center",
        margin: 0,
        style: {
          fontSize: "10px",
          color: "#00e396",
        },
      },
    },
    tooltip: {
      y: [
        {
          title: {
            formatter: function (val) {
              return val;
            },
          },
        },
        {
          title: {
            formatter: function (val) {
              return val;
            },
          },
        },
        {
          title: {
            formatter: function (val) {
              return val;
            },
          },
        },
      ],
    },
    grid: {
      borderColor: "#f1f1f1",
    },
  };

  const series = [
    {
      name: "February",
      data: prevMonthGraph,
    },
    {
      name: "March",
      data: currentMonthGraph,
    },
  ];

  return (
    <Chart
      options={options}
      className='test'
      series={series}
      sx={{ minHeight: "200px" }}
      type='line'
      width='98%'
    />
  );
};

export default SummaryChart;

// const options = {
//   chart: {
//     width: "100%",
//     type: "line",
//     toolbar: {
//       show: false,
//     },
//   },
//   grid: {
//     show: false,
//     padding: {
//       top: 0,
//       right: 0,
//       bottom: 0,
//       left: 0,
//     },
//   },
//   dataLabels: {
//     enabled: false,
//   },
//   legend: {
//     show: true,
//     labels: {
//       colors: ["#66bb6a", "rgba(115, 186, 251, 1)"],
//     },
//     markers: {
//       size: 8,
//       strokeWidth: 2,
//       fillColors: ["#66bb6a", "rgba(115, 186, 251, 1)"],
//     },
//     onItemClick: {
//       toggleDataSeries: false,
//     },
//     tooltipHoverFormatter: function (val, opts) {
//       return (
//         val +
//         " - <strong>" +
//         opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
//         "</strong>"
//       );
//     },
//   },
//   // fill: {
//   //   // type: "gradient",
//   //   // gradient: {
//   //   //   shadeIntensity: 1,
//   //   //   opacityFrom: 0.9,
//   //   //   opacityTo: 0.7,
//   //   //   stops: [0, 90, 100],
//   //   // },
//   //   // colors: ["#66bb6a"],
//   // },
//   stroke: {
//     colors: ["#66bb6a", "rgba(115, 186, 251, 1)"],
//     width: 3,
//     curve: "smooth",
//   },
//   yaxis: {
//     labels: {
//       show: false,
//     },
//     title: {
//       text: "Months",
//       align: "center",
//       style: {
//         fontSize: "10px",
//         color: "#66bb6a",
//       },
//     },
//   },
//   xaxis: {
//     categories: [
//       "Day 1",
//       "Day 2",
//       "Day 3",
//       "Day 4",
//       "Day 5",
//       "Day 6",
//       "Day 7",
//       "Day 8",
//       "Day 9",
//       "Day 10",
//       "Day 11",
//       "Day 12",
//       "Day 13",
//       "Day 14",
//       "Day 15",
//       "Day 16",
//       "Day 17",
//       "Day 18",
//       "Day 19",
//       "Day 20",
//       "Day 21",
//       "Day 22",
//       "Day 23",
//       "Day 24",
//       "Day 25",
//       "Day 26",
//       "Day 27",
//       "Day 28",
//       "Day 29",
//       "Day 30",
//     ],
//     labels: {
//       show: false,
//     },
//     axisBorder: {
//       show: false,
//     },
//     tooltip: {
//       enabled: true,
//     },
//     title: {
//       text: "Days",
//       align: "center",
//       margin: 0,
//       offsetY: -30,
//       style: {
//         fontSize: "10px",
//         color: "#66bb6a",
//       },
//     },
//   },
//   tooltip: {
//     y: [
//       {
//         title: {
//           formatter: function (val) {
//             return val;
//           },
//         },
//       },
//       {
//         title: {
//           formatter: function (val) {
//             return val;
//           },
//         },
//       },
//       {
//         title: {
//           formatter: function (val) {
//             return val;
//           },
//         },
//       },
//     ],
//   },
// };
